import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@/providers/auth-provider";
import { BreakGlassProvider } from "@/providers/break-glass-provider";
import { ThemeProvider } from "@/providers/theme-provider";
import { AiScribeProvider } from "@/providers/ai-scribe-provider";
import { AIScribeFloater } from "@/components/encounters/ai-scribe-floater";
import { ErrorBoundary } from "@/components/shared/error-boundary";
import { ToastProvider } from "@/components/ui/toast";
import { createQueryClient } from "@/lib/query-client";
import App from "./App";
import "./index.css";
import "@/lib/stale-chunk-reload";

const queryClient = createQueryClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeProvider>
          <ToastProvider>
            <AuthProvider>
              <BreakGlassProvider>
              <AiScribeProvider>
                <ErrorBoundary>
                  <App />
                </ErrorBoundary>
                <AIScribeFloater />
              </AiScribeProvider>
              </BreakGlassProvider>
            </AuthProvider>
          </ToastProvider>
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
